/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import {
  Avatar,
  Box,
  Button,
  FormLabel,
  LinearProgress,
  SwipeableDrawer,
  Tooltip,
  Typography,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {
  CheckCircleOutlineRounded,
  CheckCircleRounded,
  CloseRounded,
  UploadRounded,
} from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
import {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
  MouseEvent,
} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  Card,
  Title,
  Text,
  Header,
  Container,
  CardUser,
  TextMinute,
  TextLoading,
  MoreArchives,
} from './styles';

import PdfAta from '../../../../assets/pdfAta.svg';

import { stringAvatar } from '../../../../utils/avatarGenerator';

import fileApi from '../../../../services/requests/arquivos/fileApi';
import {
  createFileRequest,
  getFileByIdRequest,
  getMeetingByIdRequest,
  Guest,
  Meeting,
  updateMeetingRequest,
} from '../../../../services';
import {
  getSignatureByMeetingIdRequest,
  updateSignatureRequest,
} from '../../../../services/requests/assinaturas/utils';
import { sendNotificationRequest } from '../../../../services/requests/docuSign/utils';
import { createLogRequest } from '../../../../services/requests/app-logs/utils';
import { MinutesProps } from '../../../../services/requests/ata/types';
import {
  Signature,
  Subscribers,
} from '../../../../services/requests/assinaturas/types';

import { ViewerFile } from '../../../../components/ViewerFile';
import { DrawerToSign } from '../../../../components/DrawerToSign';
import { DrawerRequestSignatures } from '../../../../components/DrawerRequestSignatures';

import useAuthStore from '../../../../store/auth';
import useMinuteStore from '../../../../store/minute';
import useCompanyStore from '../../../../store/companies';
import useMeetingStore from '../../../../store/meetings';
import useControlMinuteState from '../../../../store/stateControlMinute';
import useArquiveStore from '../../../../store/arquives';

interface MeetingMinutesProps {
  meetingGuests: Guest[];
  meetingSelect: Meeting;
  meetingFinish: boolean;
  setActiveStep: (type: number) => void;
  setMeetingFinish: (type: boolean) => void;
  setThemesFinish: (type: boolean) => void;
}

export const MeetingMinutes = ({
  meetingGuests,
  meetingFinish,
  setActiveStep,
  setMeetingFinish,
  setThemesFinish,
}: MeetingMinutesProps) => {
  const params = useParams();
  const timerRef = useRef<any>(null);
  const navigate = useNavigate();

  const setMinute = useMinuteStore(state => state.setMinute);
  const minute = useMinuteStore(state => state.minute);
  const meetingSelect = useMeetingStore(state => state.selectedMeeting);
  const setBreadcrumbs = useArquiveStore(state => state.setBreadcrumbs);
  const user = useAuthStore(state => state.user);
  const setSelectedMeeting = useMeetingStore(
    state => state.setSelectedMeetings,
  );
  const stateControlMinute = useControlMinuteState(
    state => state.stateControlMinute,
  );
  const setStateControlMinute = useControlMinuteState(
    state => state.setStateControlMinute,
  );
  const selectedCompany = useCompanyStore(state => state.selectedCompany);

  const [minuteConverted, setMinuteConverted] = useState('');
  const [minuteConvertedToBlob, setMinuteConvertedToBlob] = useState<any>();
  const [minuteToBase64, setMinuteToBase64] = useState<any>();
  const [minuteName, setMinuteName] = useState('');
  const [stepDrawer, setStepDrawer] = useState('assinaturas');
  const [openDrawerSignatures, setOpenDrawerSignatures] = useState(false);
  const [openDrawerRequestSignatures, setOpenDrawerRequestSignatures] =
    useState(false);
  const [openDrawerToSign, setOpenDrawerToSign] = useState(false);
  const [urlToSign, setUrlToSign] = useState('');
  const [loading, setLoading] = useState(true);
  const [openModalMinute, setOpenModalMinute] = useState(false);
  const [signedList, setSignedList] = useState<Subscribers[]>();
  const [pendentList, setPendentList] = useState<Subscribers[]>();
  const [loadingMinuteState, setLoadingMinuteState] = useState(false);
  const [loadingSignaturesControl, setLoadingSignaturesControl] =
    useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [hasSomeSignature, setHasSomeSignature] = useState(false);
  const [signature, setSignature] = useState<any>();

  const userOnCompany = selectedCompany?.users?.some(u => u.id === user?.id);
  const userFiltered = meetingSelect?.guests?.find(u => u?.id === user?.id);
  const hasOwnerUserOnPendentList = minute?.signatures?.find(
    u => u?.id === user?.id,
  );

  const handleSignatures = useCallback(async () => {
    try {
      const response = await getSignatureByMeetingIdRequest(
        params?.id as string,
      );

      if (response?.status === 200) {
        const subs = response?.data.subscribers;

        const signatureData = response?.data;
        const subscribers = signatureData?.subscribers;

        const assinados = subscribers?.filter(
          (s: Subscribers) => s.isSigned === true,
        );
        const pendentes = subscribers?.filter(
          (s: Subscribers) => s.isSigned === false,
        );

        setSignedList(assinados);
        setPendentList(pendentes);

        setHasSomeSignature(subscribers.length > 0);

        // eslint-disable-next-line no-restricted-syntax
        for (let s of subs) {
          if (s?.id === user?.id && s?.isSigned === true) {
            clearInterval(timerRef.current);
            setMinute({
              ...minute,
              signed: true,
            });
            setStateControlMinute(false);
            setLoadingMinuteState(false);
          }
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingSignaturesControl(false);
    }
  }, [minute, params?.id, setMinute, setStateControlMinute, user?.id]);

  // useEffect(() => {
  //   if (stateControlMinute === true) {
  //     timerRef.current = setInterval(() => handleSignatures(), 5000);
  //     setLoadingMinuteState(true);
  //     setTimeout(() => {
  //       clearInterval(timerRef.current);
  //       setLoadingMinuteState(false);
  //       setStateControlMinute(false);
  //     }, 20000);
  //   }
  // }, [stateControlMinute]);

  useEffect(() => {
    if (minute?.status === '') {
      setTimeout(() => setLoading(false), 1000);
    }
  }, [minute?.status]);

  const loadFileMinuteById = useCallback(
    // eslint-disable-next-line consistent-return
    async (fileId: string) => {
      try {
        const response = await getFileByIdRequest(
          fileId,
          selectedCompany?.id as string,
          user?.id as string,
        );

        const responseBlob = await fileApi.getBlob(
          response?.data.key,
          user?.id as string,
          selectedCompany?.id as string,
        );

        return responseBlob;
      } catch (err: any) {
        console.log(err);
        toast.warning('Sem permissão para acessar o documento');
      } finally {
        setLoading(false);
      }
    },
    [selectedCompany?.id, user?.id],
  );

  const loadFileInfo = useCallback(
    async (fileId: string) => {
      try {
        const response = await getFileByIdRequest(
          fileId,
          selectedCompany?.id as string,
          user?.id as string,
        );

        const responseBlob = await fileApi.getBlob(
          response?.data.key,
          user?.id as string,
          selectedCompany?.id as string,
        );

        if (response?.status === 200) {
          let reader = new FileReader();
          reader.readAsDataURL(responseBlob);
          reader.onload = ev => {
            setMinuteToBase64(ev.target?.result?.slice(28) as string);
          };
          setMinuteName(response?.data?.original_name);

          if (!meetingSelect?.envelope_id) {
            setMinute({
              status: 'CS1',
              fileId,
              name: response?.data?.original_name,
              signatures: [],
              signed: false,
            });
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    },
    [meetingSelect?.envelope_id, selectedCompany?.id, setMinute, user?.id],
  );

  useEffect(() => {
    if (meetingSelect?.file_id) {
      loadFileInfo(meetingSelect.file_id);
    }
  }, [meetingSelect?.file_id]);

  // const loadSignatureByMeetingId = useCallback(async () => {
  //   try {
  //     const response = await getSignatureByMeetingIdRequest(
  //       meetingSelect?.id as string,
  //     );

  //     if (response?.status === 200) {
  //       const signature = response?.data;
  //       const subscribers = signature?.subscribers;

  //       const assinados = subscribers?.filter(
  //         (s: Subscribers) => s.isSigned === true,
  //       );
  //       const pendentes = subscribers?.filter(
  //         (s: Subscribers) => s.isSigned === false,
  //       );

  //       setSignedList(assinados);
  //       setPendentList(pendentes);

  //       if (
  //         meetingSelect?.envelope_id &&
  //         meetingSelect?.file_id &&
  //         (pendentList as Subscribers[]) === undefined &&
  //         (signedList as Subscribers[]) === undefined
  //       ) {
  //         setMinute({
  //           status: 'CS1',
  //           fileId: meetingSelect?.file_id,
  //           name: signature?.ata?.original_name,
  //           signatures: [],
  //           signed: false,
  //         });
  //       }

  //       const subscriberFounded = subscribers?.find(
  //         (s: Signature) => s?.id === user?.id,
  //       );

  //       let isSigned = false;
  //       let status = 'CS2';

  //       if (subscriberFounded) {
  //         isSigned = subscriberFounded?.isSigned;
  //         status = 'CS2';
  //       }

  //       setMinute({
  //         status,
  //         fileId: meetingSelect?.file_id as string,
  //         name: signature?.ata?.original_name,
  //         signatures: signature?.subscribers,
  //         signed: isSigned,
  //       });
  //     }
  //     if (!response && meetingSelect?.envelope_id && meetingSelect?.file_id) {
  //       setMinute({
  //         status: 'CS1',
  //         fileId: meetingSelect?.file_id,
  //         name: minuteName,
  //         signatures: [],
  //         signed: false,
  //       });
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [
  //   meetingSelect?.id,
  //   meetingSelect?.envelope_id,
  //   meetingSelect?.file_id,
  //   pendentList,
  //   signedList,
  //   setMinute,
  //   user?.id,
  //   minuteName,
  // ]);

  const loadSignatureByMeetingIdD4sign = useCallback(async () => {
    try {
      const response = await getSignatureByMeetingIdRequest(
        meetingSelect?.id as string,
      );

      if (response?.status === 200) {
        const signatureData = response?.data;
        const subscribers = signatureData?.subscribers;

        const assinados = subscribers?.filter(
          (s: Subscribers) => s.isSigned === true,
        );
        const pendentes = subscribers?.filter(
          (s: Subscribers) => s.isSigned === false,
        );
        setSignature(signatureData);
        setSignedList(assinados);
        setPendentList(pendentes);
        setHasSomeSignature(subscribers.length > 0);

        if (
          meetingSelect?.envelope_id &&
          meetingSelect?.file_id &&
          (pendentList as Subscribers[]) === undefined &&
          (signedList as Subscribers[]) === undefined
        ) {
          setMinute({
            status: 'CS2',
            fileId: meetingSelect?.file_id,
            name: signatureData?.ata?.original_name,
            signatures: [],
            signed: false,
          });
        }

        const subscriberFounded = subscribers?.find(
          (s: Signature) => s?.id === user?.id,
        );

        let isSigned = false;
        let status = 'CS2';

        if (subscriberFounded) {
          isSigned = subscriberFounded?.isSigned;
          status = 'CS2';
        }

        setMinute({
          status,
          fileId: meetingSelect?.file_id as string,
          name: signatureData?.ata?.original_name,
          signatures: signatureData?.subscribers,
          signed: isSigned,
        });
      }
      if (!response && meetingSelect?.envelope_id && meetingSelect?.file_id) {
        setMinute({
          status: 'CS1',
          fileId: meetingSelect?.file_id,
          name: minuteName,
          signatures: [],
          signed: false,
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [
    meetingSelect?.id,
    meetingSelect?.envelope_id,
    meetingSelect?.file_id,
    pendentList,
    signedList,
    setMinute,
    user?.id,
    minuteName,
  ]);

  const handleOpenDrawerSignaturesControls = useCallback(
    (event: MouseEvent) => {
      event.stopPropagation();
      setOpenDrawerSignatures(true);
      setLoadingSignaturesControl(true);
      handleSignatures();
    },
    [handleSignatures],
  );

  // useEffect(() => {
  //   if (meetingSelect?.envelope_id) {
  //     loadSignatureByMeetingId();
  //   }
  // }, [meetingSelect?.envelope_id, minuteName]);

  useEffect(() => {
    if (meetingSelect?.envelope_id) {
      loadSignatureByMeetingIdD4sign();
    }
  }, [meetingSelect?.envelope_id]);

  const handleCloseDrawer = () => {
    setOpenDrawerSignatures(false);
    setStepDrawer('assinaturas');
  };

  const handleMinuteUpload = useCallback(
    async (e: any) => {
      try {
        setLoading(true);
        const selectedFile = e.target.files[0];
        const nameFile = e.target.value.slice(12);
        setMinuteName(nameFile);

        const arquiveData = {
          original_name: selectedFile.name,
          mimetype: selectedFile.type,
          size: selectedFile.size,
          key: selectedFile.name,
          is_downloaded: true,
          is_main: false,
          is_public: true,
          localFile: selectedFile,
          folder_id: meetingSelect?.folder_id,
        };

        const fileResponse = await createFileRequest(
          arquiveData as any,
          user?.id as string,
          selectedCompany?.id as string,
        );

        if (fileResponse?.status === 201) {
          const meetingData: Partial<Meeting> = {
            file_id: fileResponse?.data?.id,
            status: 'MS4',
            refresh_token_zoom: meetingSelect?.refresh_token_zoom,
          };
          setSelectedMeeting({
            ...(meetingSelect as Meeting),
            file_id: fileResponse?.data?.id as string,
          });
          setActiveStep(3);
          setThemesFinish(true);
          setMeetingFinish(true);
          const meetingResponse = await updateMeetingRequest(
            meetingData,
            meetingSelect?.id as string,
            user?.id as string,
            selectedCompany?.id as string,
          );

          if (meetingResponse?.status === 200) {
            if (selectedFile) {
              let reader = new FileReader();
              reader.readAsDataURL(selectedFile);
              reader.onload = ev => {
                setMinuteConverted(ev.target?.result?.slice(28) as string);
              };
              setMinute({
                name: nameFile,
                fileId: fileResponse?.data.id,
                signatures: [],
                signed: false,
                status: 'CS1',
              });
            }
            toast.success('Arquivo da Ata salvo com sucesso');
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
    [
      meetingSelect,
      selectedCompany?.id,
      setActiveStep,
      setMeetingFinish,
      setMinute,
      setSelectedMeeting,
      setThemesFinish,
      user?.id,
    ],
  );

  const handleToSign = useCallback(
    async (event: MouseEvent) => {
      event.stopPropagation();

      try {
        setLoading(true);

        const response = await getMeetingByIdRequest(
          params?.id as string,
          user?.id as string,
        );

        setUrlToSign(
          `https://secure.d4sign.com.br/embed/viewblob/${response?.envelope_id}?email=${user?.email}`,
        );
        setOpenDrawerToSign(true);

        // const data = {
        //   meetingId: params?.id as string,
        //   returnUrl: `${process.env.REACT_APP_API_URL}/assinado-sucesso`,
        //   email: user?.email as string,
        //   name: user?.name as string,
        //   clientUserId: user?.id as string,
        // };

        // const response = await postToSign(data);

        // const log: LogsProps = {
        //   action: 'Criou',
        //   company_id: selectedCompany?.id as string,
        //   description: `Efetuou uma assinatura no documento ${minuteName}`,
        //   local: 'Assinaturas',
        //   name: user?.name as string,
        //   user_id: user?.id as string,
        // };

        // await createLogRequest(log);

        // setUrlToSign(response?.data.url);

        // if (response) {
        //   setOpenDrawerToSign(true);
        // }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    },
    [params?.id, user?.email, user?.id],
  );

  const handleSendReminder = useCallback(async () => {
    setDisabledButton(true);
    try {
      setLoadingSignaturesControl(true);
      const signersToNotification = pendentList?.map(s => ({
        name: s?.name,
        email: s?.email,
        id: s?.id,
      }));

      const data = {
        meetingId: meetingSelect?.id,
        isDocumentInBase: false,
        userId: user?.id,
        signers: signersToNotification,
      };

      const response = await sendNotificationRequest(data);

      if (response?.status === 201) {
        toast.success('Lembrete de assinatura reenviado com sucesso');
        setStepDrawer('successMessage');
      }
    } catch (err) {
      toast.error(
        'Ocorreu um erro ao reenviar o lembrete. Por favor, tente novamente mais tarde.',
      );
      console.error('handleSendReminder => ', err);
    } finally {
      setLoadingSignaturesControl(false);
      setDisabledButton(false);
    }
  }, [meetingSelect?.id, pendentList, user?.id]);

  const handleOpenMinute = useCallback(
    async (event: MouseEvent) => {
      event.stopPropagation();
      try {
        const blob = await loadFileMinuteById(meetingSelect?.file_id as string);

        const url = URL.createObjectURL(blob as Blob);

        setMinuteConvertedToBlob(url);
        setOpenModalMinute(true);
      } catch (err) {
        console.log(err);
      }
    },
    [loadFileMinuteById, meetingSelect?.file_id],
  );

  async function createLogMinuteRequest() {
    try {
      await createLogRequest({
        name: user?.name as string,
        user_id: user?.id as string,
        company_id: selectedCompany?.id as string,
        local: 'Reuniões',
        action: 'Visualizou',
        description: `Visualizou a ata da reunião ${meetingSelect?.title}`,
      });
    } catch (err) {
      console.log(err);
    }
  }

  const goToArchives = useCallback(
    (folderId: string) => {
      setBreadcrumbs([
        {
          name: 'Home',
          route: 'hbase-conhecimento',
          id: null,
        },
        {
          name: meetingSelect?.title as string,
          route: `/folder/${folderId}`,
          id: folderId,
        },
      ]);
      navigate(`/home/base-conhecimento/folder/${folderId}`);
    },
    [meetingSelect?.title, navigate, setBreadcrumbs],
  );

  useEffect(() => {
    if (openModalMinute) {
      createLogMinuteRequest();
    }
  }, [openModalMinute]);

  const drawerToSign = () => {
    return (
      <Box width="95vw" height="100%">
        <DrawerToSign
          setOpenDrawerToSign={setOpenDrawerToSign}
          urlToSign={urlToSign}
          setMinute={setMinute}
          minute={minute as MinutesProps}
          setStateControlMinute={setStateControlMinute}
          stateControlMinute={stateControlMinute}
        />
      </Box>
    );
  };

  const drawerRequestSignatures = () => {
    return (
      <DrawerRequestSignatures
        setOpenDrawer={setOpenDrawerRequestSignatures}
        listagemConvidados={meetingGuests}
        setUrlToSign={setUrlToSign}
        setMinute={setMinute}
        minuteConverted={minuteToBase64}
        minute={minute as MinutesProps}
        setLoadingMinuteState={setLoadingMinuteState}
      />
    );
  };

  const drawerShowSignatures = () => {
    return (
      <Box height="100%">
        <>
          {stepDrawer === 'assinaturas' && (
            <Box
              width="480px"
              padding="20px"
              height="100%"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
            >
              <Box>
                <Header>
                  <CloseRounded
                    sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
                    onClick={handleCloseDrawer}
                  />
                  <span className="title">Assinatura</span>
                </Header>

                {loadingSignaturesControl ? (
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '50px',
                    }}
                  >
                    <CircularProgress size={30} />
                  </Box>
                ) : (
                  <>
                    <Box>
                      {signedList && signedList?.length > 0 && (
                        <Container mt="20px">
                          <CheckCircleRounded color="success" />
                          <span className="assinados">Quem assinou</span>
                        </Container>
                      )}
                      <Box width="100%" mt="20px">
                        {signedList?.map((c: Subscribers) => (
                          <CardUser>
                            <Box display="flex" alignItems="center" gap="10px">
                              {c?.avatar_url ? (
                                <Avatar sx={{ width: '40px' }}>
                                  <img
                                    src={c?.avatar_url as string}
                                    alt="Foto de perfil"
                                    style={{ width: '100%' }}
                                  />
                                </Avatar>
                              ) : (
                                <Avatar
                                  {...stringAvatar(c.name!)}
                                  sx={{ width: '40px' }}
                                />
                              )}
                              <span className="name">{c.name}</span>
                            </Box>
                            {/* <span className="createdAt">
                        {dayjs(c.created_at).format('DD/MM/YYYY')}
                      </span> */}
                          </CardUser>
                        ))}
                      </Box>
                    </Box>
                    <Box mt="20px">
                      {pendentList && pendentList?.length > 0 && (
                        <Container>
                          <CheckCircleRounded color="error" />
                          <span className="pendentes">
                            Pendente de assinatura
                          </span>
                        </Container>
                      )}
                      <Box width="100%" mt="20px">
                        {pendentList?.map((c: Subscribers) => (
                          <CardUser>
                            <Box display="flex" alignItems="center" gap="10px">
                              {c?.avatar_url ? (
                                <Avatar sx={{ width: '40px' }}>
                                  <img
                                    src={c?.avatar_url as string}
                                    alt="Foto de perfil"
                                    style={{ width: '100%' }}
                                  />
                                </Avatar>
                              ) : (
                                <Avatar
                                  {...stringAvatar(c.name!)}
                                  sx={{ width: '40px' }}
                                />
                              )}
                              <span className="name">{c.name}</span>
                            </Box>
                          </CardUser>
                        ))}
                      </Box>
                    </Box>
                  </>
                )}
              </Box>
              {pendentList && pendentList?.length > 0 && (
                <Box
                  sx={{ width: '100%', display: 'flex', justifyContent: 'end' }}
                >
                  {userFiltered?.profile === 'GS1' ? (
                    <Button
                      variant="outlined"
                      sx={{ marginTop: '30px' }}
                      onClick={() => setStepDrawer('sendEmail')}
                    >
                      Reenviar solicitação
                    </Button>
                  ) : null}
                </Box>
              )}
            </Box>
          )}
        </>
        <>
          {stepDrawer === 'sendEmail' && (
            <Box
              width="480px"
              padding="20px"
              height="100%"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
            >
              <Box height="100%">
                <Header>
                  <CloseRounded
                    sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
                    onClick={handleCloseDrawer}
                  />
                  <span className="title">Assinatura</span>
                </Header>
                {loadingSignaturesControl ? (
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '50px',
                    }}
                  >
                    <CircularProgress size={30} />
                  </Box>
                ) : (
                  <Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mt="20px"
                    >
                      <Container>
                        <span className="text">Quem receberá a mensagem</span>
                      </Container>
                      <Tooltip
                        TransitionProps={{ style: { fontSize: '14px' } }}
                        title="O link de assinatura de um documento poderá ser reenviado nos seguintes intervalados de tempo: 1º em 1 min, 2º em 5 min, 3º em 30 min. E a partir disso o link poderá ser reenviado de 60 em 60 min."
                      >
                        <HelpOutlineIcon />
                      </Tooltip>
                    </Box>
                    <Box width="100%" mt="20px" mb="20px">
                      {pendentList?.map(c => (
                        <CardUser>
                          <Box display="flex" alignItems="center" gap="10px">
                            {c?.avatar_url ? (
                              <Avatar sx={{ width: '40px' }}>
                                <img
                                  src={c?.avatar_url as string}
                                  alt="Foto de perfil"
                                  style={{ width: '100%' }}
                                />
                              </Avatar>
                            ) : (
                              <Avatar
                                {...stringAvatar(c.name!)}
                                sx={{ width: '40px' }}
                              />
                            )}
                            <span className="name">{c?.name}</span>
                          </Box>
                        </CardUser>
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
              <Box
                sx={{ width: '100%', display: 'flex', justifyContent: 'end' }}
              >
                <Button
                  variant="contained"
                  color="success"
                  sx={{ marginTop: '30px', color: '#ffffff' }}
                  onClick={handleSendReminder}
                  disabled={disabledButton}
                >
                  Enviar e-mail
                </Button>
              </Box>
            </Box>
          )}
        </>
        <>
          {stepDrawer === 'successMessage' && (
            <Box width="480px" padding="20px">
              <Header>
                <CloseRounded
                  sx={{ cursor: 'pointer', position: 'absolute', left: '0' }}
                  onClick={handleCloseDrawer}
                />
                <span className="title">Assinatura</span>
              </Header>
              <Box
                display="flex"
                alignItems="center"
                flexDirection="column"
                gap="10px"
                mt="50px"
              >
                <CheckCircleOutlineRounded
                  color="success"
                  sx={{ width: '66px', height: '66px' }}
                />
                <Container display="flex" flexDirection="column">
                  <span className="title">
                    Assinatura solicitada com sucesso!
                  </span>
                  <span className="desc">
                    Os usuários serão solicitados para assinar o documento, e
                    receberão um e-mail de notificação.
                  </span>
                </Container>
                <Button
                  variant="outlined"
                  sx={{ marginTop: '20px' }}
                  onClick={handleCloseDrawer}
                >
                  Ok, fechar
                </Button>
              </Box>
            </Box>
          )}
        </>
      </Box>
    );
  };

  const handleEditSignatures = useCallback(async () => {
    try {
      const newSignatures: any = signature?.subscribers?.map(
        (sub: Subscribers) => {
          if (sub?.id === user?.id) {
            const subUpdated: Subscribers = {
              ...sub,
              isSigned: true,
            };
            return subUpdated;
          }
          return newSignatures;
        },
      );

      console.log({ newSignatures });

      const updateSignature: any = {
        ata: signature?.ata,
        file_id: signature?.file_id,
        meeting_id: signature?.meeting_id,
        owner_id: signature?.owner_id,
        file: signature?.file,
        subscribers: [...newSignatures],
        subscribers_ids: signature?.subscribers_ids,
      };

      await updateSignatureRequest(signature?.id as string, updateSignature);
    } catch (err) {
      console.log(err);
    }
  }, [signature, user?.id]);

  useEffect(() => {
    window.addEventListener(
      'message',
      event => {
        if (event.data === 'signed') {
          setOpenDrawerToSign(false);
          setMinute({
            ...minute,
            signed: true,
            status: 'CS2',
          });
          // handleEditSignatures();
          toast.success('Assinado com sucesso!', { toastId: 1 });
        }
        if (event.data === 'wrong-data') {
          toast.error('Erro na assinatura');
        }
      },
      false,
    );
  }, [handleEditSignatures, minute, setMinute]);

  return (
    <Box width="100%">
      <Box
        width="100%"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={minute ? '20px' : '0'}
      >
        <Title>Ata da reunião</Title>
        {minute?.status === '' &&
          (loading ? (
            <CircularProgress size={30} />
          ) : !loading && userFiltered?.profile === 'GS1' ? (
            <FormLabel htmlFor="input-file" className="add-logo">
              <Button
                variant="contained"
                component="label"
                sx={{
                  padding: '6px 16px',
                  width: '202px',
                  height: '40px',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                <input
                  type="file"
                  name="file"
                  id="input-file"
                  onChange={handleMinuteUpload}
                  accept="application/pdf"
                  hidden
                />
                Upload da ata
              </Button>
            </FormLabel>
          ) : null)}
        {minute?.status !== '' && (
          <MoreArchives
            onClick={() => goToArchives(meetingSelect?.folder_id as string)}
          >
            {userFiltered?.profile === 'GS1'
              ? 'Adicionar mais arquivos a reunião'
              : 'Ver outros arquivos da reunião'}
          </MoreArchives>
        )}
      </Box>
      <>
        {minute?.status === '' && (
          <Typography>Nenhuma ata adicionada até o momento...</Typography>
        )}
      </>

      {(minute?.status === 'CS1' &&
        (loading ? (
          <Box>
            <LinearProgress />
          </Box>
        ) : (
          <Card>
            <Box
              display="flex"
              alignItems="center"
              gap="10px"
              onClick={
                userOnCompany
                  ? e => handleOpenMinute(e)
                  : () =>
                      toast.warning(
                        'Você não tem permissão para visualizar a ata',
                      )
              }
            >
              <img src={PdfAta} alt="pdf da ata" />
              <Text>{minute.name}</Text>
            </Box>
            {loadingMinuteState ? (
              <Box display="flex" alignItems="center" gap="10px">
                <TextLoading>
                  Verificando solicitação de assinatura...
                </TextLoading>
                <CircularProgress size={30} />
              </Box>
            ) : (
              userFiltered?.profile === 'GS1' && (
                <Box display="flex" alignItems="center" gap="10px">
                  <FormLabel htmlFor="input-file" className="add-logo">
                    <Button
                      className="archive"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                      component="label"
                    >
                      <input
                        type="file"
                        name="file"
                        id="input-file"
                        onChange={handleMinuteUpload}
                        accept="application/pdf"
                        hidden
                      />
                      <UploadRounded /> Alterar arquivo
                    </Button>
                  </FormLabel>

                  <Fragment key="right">
                    <Button
                      variant="outlined"
                      className="requestSignatures"
                      onClick={() => setOpenDrawerRequestSignatures(true)}
                    >
                      Solicitar assinaturas
                    </Button>
                    <SwipeableDrawer
                      onClose={() => setOpenDrawerRequestSignatures(true)}
                      onOpen={() => setOpenDrawerRequestSignatures(true)}
                      open={openDrawerRequestSignatures}
                      anchor="right"
                    >
                      {drawerRequestSignatures()}
                    </SwipeableDrawer>
                  </Fragment>
                </Box>
              )
            )}
          </Card>
        ))) ||
        (minute?.status === 'CS2' &&
          (loading ? (
            <Box>
              <LinearProgress />
            </Box>
          ) : (
            <>
              <Card sx={{ paddingY: 0 }}>
                <Fragment key="right">
                  <Box
                    display="flex"
                    alignItems="center"
                    gap="10px"
                    onClick={
                      userOnCompany
                        ? e => handleOpenMinute(e)
                        : () =>
                            toast.warning(
                              'Você não tem permissão para visualizar a ata',
                            )
                    }
                    flex={1}
                  >
                    <img src={PdfAta} alt="pdf da ata" />
                    <Text>{minute.name}</Text>
                  </Box>
                  {loadingMinuteState ? (
                    <Box display="flex" alignItems="center" gap="10px">
                      <TextLoading>Verificando sua assinatura...</TextLoading>
                      <CircularProgress size={30} />
                    </Box>
                  ) : (
                    <Box display="flex" alignItems="center" gap="20px">
                      <Fragment key="right">
                        {userOnCompany ? (
                          <Button
                            className="signatures"
                            variant="outlined"
                            onClick={e => handleOpenDrawerSignaturesControls(e)}
                          >
                            Ver assinaturas
                          </Button>
                        ) : null}
                        <SwipeableDrawer
                          onClose={handleCloseDrawer}
                          onOpen={() => setOpenDrawerSignatures(true)}
                          open={openDrawerSignatures}
                          anchor="right"
                        >
                          {drawerShowSignatures()}
                        </SwipeableDrawer>
                      </Fragment>
                      {minute?.signed ? (
                        <Box display="flex" alignItems="flex" gap="10px">
                          <CheckCircleOutlineRounded color="success" />
                          <TextMinute>Assinado</TextMinute>
                        </Box>
                      ) : (
                        hasOwnerUserOnPendentList && (
                          <Button
                            variant="contained"
                            className="toSign"
                            onClick={e => handleToSign(e)}
                          >
                            Assinar
                          </Button>
                        )
                      )}
                    </Box>
                  )}
                  <SwipeableDrawer
                    onClose={() => setOpenDrawerToSign(true)}
                    onOpen={() => setOpenDrawerToSign(true)}
                    anchor="right"
                    open={openDrawerToSign}
                  >
                    {drawerToSign()}
                  </SwipeableDrawer>
                </Fragment>
              </Card>
              {loading && <LinearProgress sx={{ marginTop: '10px' }} />}
            </>
          ))) ||
        (minute?.status === 'CS3' &&
          (loading ? (
            <Box>
              <LinearProgress />
            </Box>
          ) : (
            <Card>
              <Box display="flex" alignItems="center" gap="10px">
                <img src={PdfAta} alt="pdf da ata" />
                <Text>{minute.name}</Text>
              </Box>
            </Card>
          )))}
      {minute?.status === 'CS4' && (
        <Card
          onClick={
            userOnCompany
              ? e => handleOpenMinute(e)
              : () =>
                  toast.warning('Você não tem permissão para visualizar a ata')
          }
        >
          <Box display="flex" alignItems="center" gap="10px">
            <img src={PdfAta} alt="pdf da ata" />
            <Text>{minute.name}</Text>
          </Box>
        </Card>
      )}

      <ViewerFile
        fileUrl={minuteConvertedToBlob}
        loading={loadingMinuteState}
        onClose={() => setOpenModalMinute(false)}
        open={openModalMinute}
        title={minuteName}
        fileId={minute?.fileId}
        isMinute
      />
    </Box>
  );
};
